import { useRequest } from 'ahooks';
import { FC, useEffect } from 'react';
import { getHistoryChat } from '../../service';
import { Tooltip } from 'antd';
import seedlingFillSvg from './seedling-fill.svg';
import useI18n from '../../../../hooks/useI18n';

export interface IHistoryProps {
  selectChat?: number;
  setSelectChat: (p: number) => void;
  refreshHistory: number;
  isLogin: boolean;
  className: string;
}

export const History: FC<IHistoryProps> = (props) => {
  const { selectChat, setSelectChat, refreshHistory, isLogin, className } =
    props;
  const { data } = useRequest(getHistoryChat, {
    refreshDeps: [refreshHistory],
    ready: isLogin,
  });
  const i18n = useI18n();

  const today = data?.data.data.today || [];
  const history = data?.data.data.history || [];

  useEffect(() => {
    const msgBox = document.getElementById(`${selectChat}-select`);
    if (msgBox) {
      msgBox.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }, [data]);

  if (!isLogin) {
    return <></>;
  }

  return (
    <div
      className={
        'w-full h-full p-4 overflow-y-auto overflow-x-hidden flex gap-6 flex-col ' +
        className
      }
    >
      <div className="w-full">
        <div className="px-4 text-xs text-[#04252B] mb-2 font-medium">
          {i18n('recent Dialogue')}
        </div>
        <div className="flex gap-1 flex-col">
          {today.map((item) => {
            if (selectChat === item.id) {
              const percent = (
                (Number(item.neutralReduction) / Number(item.topicReduction)) *
                100
              ).toFixed(0);
              return (
                <div
                  className="bg-[#EAECF0] w-[16.5rem] h-[6rem] p-4 rounded-2xl mb-2"
                  id={`${selectChat}-select`}
                >
                  <div className="truncate text-sm font-medium text-[#04252B]">
                    {item.topicTitle}
                  </div>
                  <div className="w-full flex justify-between mb-1">
                    {percent !== '0' && (
                      <div className="justify-self-start">
                        <Tooltip title={i18n('Neutralized emissions')}>
                          <span className="text-sm text-[#08C0AC]">
                            {item.neutralReduction}
                          </span>
                        </Tooltip>
                        <span className="text-xs text-[#04252B52] mx-1">
                          {item.neutralReductionUnit}
                        </span>
                      </div>
                    )}
                    {(percent === '0' || percent === '100') && <div></div>}
                    {percent !== '100' && (
                      <div className="justify-self-end">
                        <span className="text-sm">{item.topicReduction}</span>
                        <span className="text-xs text-[#04252B52] mx-1">
                          {item.topicReductionUnit}
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="w-full bg-[#343A40] h-[0.38rem] rounded-md relative">
                    <div
                      className="bg-[#08C0AC] h-[0.38rem] absolute top-0 left-0 rounded-md"
                      style={{
                        width: `${percent}%`,
                      }}
                    ></div>
                    <img
                      src={seedlingFillSvg}
                      className={`absolute top-[-0.23rem] w-[0.875rem] h-[0.875rem]`}
                      style={{
                        left: `calc(${percent}% - 6px)`,
                      }}
                      alt=""
                    />
                  </div>
                </div>
              );
            }
            return (
              <div
                key={item.id}
                onClick={() => setSelectChat(item.id)}
                className="truncate px-4 py-3 w-full cursor-pointer text-sm text-[#04252bcc] hover:bg-[#EAECF0] hover:rounded-2xl"
              >
                {item.topicTitle}
              </div>
            );
          })}
        </div>
      </div>
      <div className="w-full">
        <div className="px-4 text-xs text-[#04252B] mb-2 font-medium">
          {i18n('HistoricalDialogue')}
        </div>
        <div className="flex gap-1 flex-col">
          {history.map((item) => {
            if (selectChat === item.id) {
              const percent = (
                (Number(item.neutralReduction) / Number(item.topicReduction)) *
                100
              ).toFixed(0);
              console.log(percent);
              return (
                <div
                  className="bg-[#EAECF0] w-[16.5rem] h-[6rem] p-4 rounded-2xl mb-2"
                  id={`${selectChat}-select`}
                >
                  <div className="truncate text-sm text-[#04252B]">
                    {item.topicTitle}
                  </div>
                  <div className="w-full flex justify-between mb-1">
                    {percent !== '0' && (
                      <div className="justify-self-start">
                        <Tooltip title={i18n('Neutralized emissions')}>
                          <span className="text-sm text-[#08C0AC]">
                            {item.neutralReduction}
                          </span>
                        </Tooltip>
                        <span className="text-xs text-[#04252B52] mx-1">
                          {item.neutralReductionUnit}
                        </span>
                      </div>
                    )}
                    {(percent === '0' || percent === '100') && <div></div>}
                    {percent !== '100' && (
                      <div className="justify-self-end">
                        <span className="text-sm">{item.topicReduction}</span>
                        <span className="text-xs text-[#04252B52] mx-1">
                          {item.topicReductionUnit}
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="w-full bg-[#343A40] h-[0.38rem] rounded-md relative">
                    <div
                      className="bg-[#08C0AC] h-[0.38rem] absolute top-0 left-0 rounded-md"
                      style={{
                        width: `${percent}%`,
                      }}
                    ></div>
                    <img
                      src={seedlingFillSvg}
                      className={`absolute top-[-0.23rem] w-[0.875rem] h-[0.875rem]`}
                      style={{
                        left: `calc(${percent}% - 6px)`,
                      }}
                      alt=""
                    />
                  </div>
                </div>
              );
            }
            return (
              <div
                key={item.id}
                onClick={() => setSelectChat(item.id)}
                className="truncate px-4 py-3 w-full cursor-pointer text-sm text-[#04252bcc] hover:bg-[#EAECF0] hover:rounded-2xl"
              >
                {item.topicTitle}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
